import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const card = { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 20, marginBottom: 16 };
const label = { fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 4, fontWeight: 600 };
const input = { width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' };
const btn = { padding: '8px 16px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: 13 };
const btnSec = { ...btn, background: '#fff', color: '#374151', border: '1px solid #d1d5db' };
const btnDanger = { ...btn, background: '#dc2626' };
const tabBtn = (a) => ({ padding: '10px 18px', border: 'none', background: 'transparent', cursor: 'pointer', fontWeight: 600, fontSize: 14, color: a ? '#2563eb' : '#6b7280', borderBottom: a ? '2px solid #2563eb' : '2px solid transparent' });

export default function StoringKoppelingen() {
  const [view, setView] = useState('list');
  const [koppelingen, setKoppelingen] = useState([]);
  const [selected, setSelected] = useState(null);
  const [msg, setMsg] = useState(null);
  const [bezig, setBezig] = useState(false);
  const [featureOff, setFeatureOff] = useState(false);

  const showMsg = (text, kleur = '#10b981') => { setMsg({ text, kleur }); setTimeout(() => setMsg(null), 4000); };

  const loadKoppelingen = useCallback(async () => {
    try {
      const r = await api.get('/storing-koppelingen');
      setKoppelingen(r.data.koppelingen || []);
      setFeatureOff(false);
    } catch (e) {
      if (e.response?.status === 403) setFeatureOff(true);
      else showMsg('Fout: ' + (e.response?.data?.message || e.message), '#dc2626');
    }
  }, []);

  useEffect(() => { loadKoppelingen(); }, [loadKoppelingen]);

  const openKopp = async (k) => {
    setSelected(k);
    setView('detail');
  };

  const nieuweKoppeling = async () => {
    const naam = window.prompt('Naam voor de nieuwe koppeling?', 'Mijn bron');
    if (!naam) return;
    try {
      const r = await api.post('/storing-koppelingen', {
        naam,
        provider: 'rest_json',
        config: { url: '', method: 'GET', headers: {}, response_path: '$', field_mapping: { extern_id: 'id', asset: '', titel: '', locatie: '', score: '' } },
        sync_interval: 5
      });
      showMsg('Koppeling aangemaakt');
      loadKoppelingen();
      setSelected(r.data.koppeling);
      setView('detail');
    } catch (e) { showMsg('Fout: ' + (e.response?.data?.message || e.message), '#dc2626'); }
  };

  const verwijderKopp = async (k) => {
    if (!window.confirm(`Koppeling "${k.naam}" verwijderen? Bestaande storingen blijven staan, maar mappings/filters/log van deze koppeling gaan weg.`)) return;
    try { await api.delete('/storing-koppelingen/' + k.id); showMsg('Verwijderd'); loadKoppelingen(); }
    catch (e) { showMsg('Fout: ' + (e.response?.data?.message || e.message), '#dc2626'); }
  };

  if (featureOff) {
    return (
      <div style={{ padding: 24, maxWidth: 800, margin: '40px auto' }}>
        <div style={{ ...card, textAlign: 'center', padding: 40 }}>
          <h2 style={{ marginTop: 0 }}>🔒 Module niet geactiveerd</h2>
          <p style={{ color: '#6b7280' }}>De module "Storing Koppelingen" staat niet aan voor uw bedrijf. Neem contact op met uw super_admin om deze te activeren.</p>
        </div>
      </div>
    );
  }

  if (view === 'detail' && selected) {
    return <KoppelingDetail kopp={selected} onBack={() => { setView('list'); loadKoppelingen(); }} onMsg={showMsg} />;
  }

  return (
    <div style={{ padding: 24, maxWidth: 1400, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
        <h1 style={{ margin: 0, fontSize: 26 }}>🔗 Storing Koppelingen</h1>
        <button style={btn} onClick={nieuweKoppeling}>+ Nieuwe koppeling</button>
      </div>
      <p style={{ color: '#6b7280', margin: '0 0 20px' }}>Externe storing-bronnen (TMS, BMS, REST API's) die automatisch storingen aan WOMsys leveren.</p>

      {msg && <div style={{ background: msg.kleur === '#10b981' ? '#dcfce7' : '#fee2e2', color: msg.kleur, padding: 12, borderRadius: 8, marginBottom: 16, fontWeight: 600 }}>{msg.text}</div>}

      {koppelingen.length === 0 ? (
        <div style={{ ...card, textAlign: 'center', padding: 40, color: '#9ca3af' }}>
          Nog geen koppelingen. Klik "+ Nieuwe koppeling" om te beginnen.
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 12 }}>
          {koppelingen.map(k => (
            <div key={k.id} style={card}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: 8 }}>
                <div>
                  <div style={{ fontSize: 17, fontWeight: 700 }}>{k.naam}</div>
                  <div style={{ fontSize: 12, color: '#6b7280' }}>Provider: {k.provider} • {k.sync_actief ? <span style={{ color: '#10b981' }}>● auto-sync actief</span> : <span>○ gestopt</span>}</div>
                </div>
                <span style={{ background: k.actief ? '#dcfce7' : '#fee2e2', color: k.actief ? '#065f46' : '#991b1b', padding: '2px 8px', borderRadius: 12, fontSize: 11, fontWeight: 600 }}>{k.actief ? 'actief' : 'inactief'}</span>
              </div>
              <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 12 }}>
                {k.laatste_sync ? `Laatste sync: ${new Date(k.laatste_sync).toLocaleString('nl-NL')}` : 'Nooit gesynct'}
                {k.laatste_fout && <div style={{ color: '#dc2626', marginTop: 4 }}>Fout: {k.laatste_fout}</div>}
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                <button style={btn} onClick={() => openKopp(k)}>Openen →</button>
                <button style={btnDanger} onClick={() => verwijderKopp(k)}>Verwijderen</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function KoppelingDetail({ kopp: koppInitial, onBack, onMsg }) {
  const [kopp, setKopp] = useState(koppInitial);
  const [tab, setTab] = useState('live');
  const [bezig, setBezig] = useState(false);
  const [items, setItems] = useState([]);
  const [totaal, setTotaal] = useState(0);
  const [filtersLive, setFiltersLive] = useState({ asset: '', titel: '', locatie: '', score_min: '', q: '' });
  const [afdelingFilters, setAfdelingFilters] = useState([]);
  const [afdelingen, setAfdelingen] = useState([]);
  const [logs, setLogs] = useState([]);
  const [nieuweFilter, setNieuweFilter] = useState({ afdeling_id: '', filter_veld: 'titel', filter_waarde: '', auto_werkorder: false });
  const [configText, setConfigText] = useState(JSON.stringify(kopp.config || {}, null, 2));
  const [naam, setNaam] = useState(kopp.naam);
  const [syncInterval, setSyncInterval] = useState(kopp.sync_interval);

  const reload = useCallback(async () => {
    try { const r = await api.get('/storing-koppelingen/' + kopp.id); setKopp(r.data.koppeling); } catch (e) {}
  }, [kopp.id]);

  const loadAfd = useCallback(async () => {
    try { const r = await api.get('/afdelingen'); setAfdelingen(r.data.afdelingen || r.data || []); } catch (e) {}
  }, []);

  const loadLive = useCallback(async () => {
    setBezig(true);
    try {
      const params = new URLSearchParams();
      Object.entries(filtersLive).forEach(([k, v]) => { if (v) params.append(k, v); });
      const r = await api.get(`/storing-koppelingen/${kopp.id}/storingen-live?` + params.toString());
      setItems(r.data.items || []); setTotaal(r.data.totaal || 0);
    } catch (e) { onMsg('Fout: ' + (e.response?.data?.message || e.message), '#dc2626'); }
    finally { setBezig(false); }
  }, [kopp.id, filtersLive, onMsg]);

  const loadFilters = useCallback(async () => {
    try { const r = await api.get(`/storing-koppelingen/${kopp.id}/filters`); setAfdelingFilters(r.data.filters || []); } catch (e) {}
  }, [kopp.id]);

  const loadLogs = useCallback(async () => {
    try { const r = await api.get(`/storing-koppelingen/${kopp.id}/log?limit=50`); setLogs(r.data.log || []); } catch (e) {}
  }, [kopp.id]);

  useEffect(() => { loadAfd(); }, [loadAfd]);
  useEffect(() => {
    if (tab === 'live') loadLive();
    if (tab === 'filters') loadFilters();
    if (tab === 'log') loadLogs();
  }, [tab, loadLive, loadFilters, loadLogs]);

  const saveKopp = async () => {
    setBezig(true);
    try {
      let configObj;
      try { configObj = JSON.parse(configText); }
      catch (e) { onMsg('Config moet geldig JSON zijn: ' + e.message, '#dc2626'); setBezig(false); return; }
      await api.put('/storing-koppelingen/' + kopp.id, { naam, config: configObj, sync_interval: parseInt(syncInterval) });
      onMsg('Opgeslagen'); reload();
    } catch (e) { onMsg('Fout: ' + (e.response?.data?.message || e.message), '#dc2626'); }
    finally { setBezig(false); }
  };

  const testKopp = async () => {
    setBezig(true);
    try {
      const r = await api.post('/storing-koppelingen/' + kopp.id + '/test');
      onMsg(r.data.success ? `OK — ${r.data.aantal} items` : 'Fout: ' + r.data.message, r.data.success ? '#10b981' : '#dc2626');
    } catch (e) { onMsg('Fout: ' + e.message, '#dc2626'); }
    finally { setBezig(false); }
  };

  const syncNu = async () => {
    setBezig(true);
    try {
      const r = await api.post('/storing-koppelingen/' + kopp.id + '/sync');
      onMsg(r.data.success ? r.data.message : 'Fout: ' + r.data.message, r.data.success ? '#10b981' : '#dc2626');
      reload();
    } catch (e) { onMsg('Fout: ' + e.message, '#dc2626'); }
    finally { setBezig(false); }
  };

  const toggleAuto = async () => {
    setBezig(true);
    try {
      const url = `/storing-koppelingen/${kopp.id}/sync/${kopp.sync_actief ? 'stop' : 'start'}`;
      const r = await api.post(url);
      onMsg(r.data.message); reload();
    } catch (e) { onMsg('Fout: ' + e.message, '#dc2626'); }
    finally { setBezig(false); }
  };

  const addFilter = async () => {
    if (!nieuweFilter.afdeling_id || !nieuweFilter.filter_waarde) { onMsg('Afdeling en waarde verplicht', '#dc2626'); return; }
    try {
      await api.post(`/storing-koppelingen/${kopp.id}/filters`, nieuweFilter);
      setNieuweFilter({ afdeling_id: '', filter_veld: 'titel', filter_waarde: '', auto_werkorder: false });
      loadFilters(); onMsg('Filter toegevoegd');
    } catch (e) { onMsg('Fout: ' + (e.response?.data?.message || e.message), '#dc2626'); }
  };

  const toggleFilter = async (f, veld) => {
    try { await api.put(`/storing-koppelingen/${kopp.id}/filters/${f.id}`, { [veld]: !f[veld] }); loadFilters(); }
    catch (e) { onMsg('Fout: ' + e.message, '#dc2626'); }
  };

  const deleteFilter = async (id) => {
    if (!window.confirm('Filter verwijderen?')) return;
    try { await api.delete(`/storing-koppelingen/${kopp.id}/filters/${id}`); loadFilters(); onMsg('Verwijderd'); }
    catch (e) { onMsg('Fout: ' + e.message, '#dc2626'); }
  };

  return (
    <div style={{ padding: 24, maxWidth: 1400, margin: '0 auto' }}>
      <button onClick={onBack} style={{ ...btnSec, marginBottom: 12 }}>← Terug naar lijst</button>
      <h1 style={{ margin: '0 0 4px', fontSize: 26 }}>🔗 {kopp.naam}</h1>
      <p style={{ color: '#6b7280', margin: '0 0 20px' }}>Provider: <strong>{kopp.provider}</strong> • Status: <strong style={{ color: kopp.sync_actief ? '#10b981' : '#6b7280' }}>{kopp.sync_actief ? 'auto-sync actief' : 'gestopt'}</strong> {kopp.laatste_sync && ` • Laatste sync: ${new Date(kopp.laatste_sync).toLocaleString('nl-NL')}`}</p>

      <div style={card}>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button style={btnSec} onClick={testKopp} disabled={bezig}>🔌 Test verbinding</button>
          <button style={btn} onClick={syncNu} disabled={bezig}>🔄 Nu syncen</button>
          <button style={kopp.sync_actief ? btnDanger : { ...btn, background: '#10b981' }} onClick={toggleAuto} disabled={bezig}>
            {kopp.sync_actief ? '⏹ Auto-sync stoppen' : '▶ Auto-sync starten'}
          </button>
        </div>
        {kopp.laatste_fout && <div style={{ color: '#dc2626', marginTop: 10, fontSize: 13 }}>Laatste fout: {kopp.laatste_fout}</div>}
      </div>

      <div style={{ display: 'flex', gap: 4, borderBottom: '1px solid #e5e7eb', marginBottom: 16 }}>
        <button style={tabBtn(tab === 'live')} onClick={() => setTab('live')}>📡 Live storingen</button>
        <button style={tabBtn(tab === 'filters')} onClick={() => setTab('filters')}>⚙️ Filters per afdeling</button>
        <button style={tabBtn(tab === 'settings')} onClick={() => setTab('settings')}>🔧 Instellingen</button>
        <button style={tabBtn(tab === 'log')} onClick={() => setTab('log')}>📜 Sync log</button>
      </div>

      {tab === 'live' && (
        <div style={card}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr) auto', gap: 8, marginBottom: 14 }}>
            <div><label style={label}>Asset</label><input style={input} value={filtersLive.asset} onChange={e => setFiltersLive({ ...filtersLive, asset: e.target.value })} placeholder="W127" /></div>
            <div><label style={label}>Type/titel</label><input style={input} value={filtersLive.titel} onChange={e => setFiltersLive({ ...filtersLive, titel: e.target.value })} placeholder="Tongen" /></div>
            <div><label style={label}>Locatie</label><input style={input} value={filtersLive.locatie} onChange={e => setFiltersLive({ ...filtersLive, locatie: e.target.value })} /></div>
            <div><label style={label}>Score ≥</label><input type="number" style={input} value={filtersLive.score_min} onChange={e => setFiltersLive({ ...filtersLive, score_min: e.target.value })} /></div>
            <div><label style={label}>Vrije tekst</label><input style={input} value={filtersLive.q} onChange={e => setFiltersLive({ ...filtersLive, q: e.target.value })} /></div>
            <div style={{ display: 'flex', alignItems: 'end' }}><button style={btn} onClick={loadLive} disabled={bezig}>🔍</button></div>
          </div>
          <div style={{ color: '#6b7280', fontSize: 13, marginBottom: 8 }}>{bezig ? 'Laden...' : `${items.length} van ${totaal} items`}</div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead><tr style={{ background: '#f9fafb' }}>
                <th style={{ textAlign: 'left', padding: 10 }}>Extern ID</th>
                <th style={{ textAlign: 'left', padding: 10 }}>Asset</th>
                <th style={{ textAlign: 'left', padding: 10 }}>Locatie</th>
                <th style={{ textAlign: 'left', padding: 10 }}>Type/titel</th>
                <th style={{ textAlign: 'right', padding: 10 }}>Score</th>
              </tr></thead>
              <tbody>
                {items.map(i => (
                  <tr key={i.extern_id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: 10, fontFamily: 'monospace', fontSize: 12, color: '#6b7280' }}>{i.extern_id}</td>
                    <td style={{ padding: 10, fontWeight: 600 }}>{i.asset}</td>
                    <td style={{ padding: 10 }}>{i.locatie}</td>
                    <td style={{ padding: 10 }}>{i.titel}</td>
                    <td style={{ padding: 10, textAlign: 'right' }}><span style={{ background: i.score >= 5 ? '#fee2e2' : i.score >= 3 ? '#fef3c7' : '#dcfce7', padding: '2px 8px', borderRadius: 12, fontWeight: 600 }}>{i.score}</span></td>
                  </tr>
                ))}
                {items.length === 0 && !bezig && <tr><td colSpan="5" style={{ padding: 30, textAlign: 'center', color: '#9ca3af' }}>Geen items</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {tab === 'filters' && (
        <div style={card}>
          <h3 style={{ marginTop: 0 }}>Nieuwe filter</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 2fr auto auto', gap: 8, marginBottom: 16, alignItems: 'end' }}>
            <div><label style={label}>Afdeling</label>
              <select style={input} value={nieuweFilter.afdeling_id} onChange={e => setNieuweFilter({ ...nieuweFilter, afdeling_id: e.target.value })}>
                <option value="">— kies —</option>
                {afdelingen.map(a => <option key={a.id} value={a.id}>{a.naam}</option>)}
              </select>
            </div>
            <div><label style={label}>Veld</label>
              <select style={input} value={nieuweFilter.filter_veld} onChange={e => setNieuweFilter({ ...nieuweFilter, filter_veld: e.target.value })}>
                <option value="titel">Titel</option>
                <option value="asset">Asset</option>
                <option value="locatie">Locatie</option>
                <option value="score">Score</option>
              </select>
            </div>
            <div><label style={label}>Waarde (substring)</label><input style={input} value={nieuweFilter.filter_waarde} onChange={e => setNieuweFilter({ ...nieuweFilter, filter_waarde: e.target.value })} placeholder="bv. Tongen failure" /></div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
              <input type="checkbox" checked={nieuweFilter.auto_werkorder} onChange={e => setNieuweFilter({ ...nieuweFilter, auto_werkorder: e.target.checked })} /> Auto-WO
            </label>
            <button style={btn} onClick={addFilter}>+ Toevoegen</button>
          </div>
          <h3>Bestaande filters</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead><tr style={{ background: '#f9fafb' }}>
              <th style={{ textAlign: 'left', padding: 10 }}>Afdeling</th>
              <th style={{ textAlign: 'left', padding: 10 }}>Veld</th>
              <th style={{ textAlign: 'left', padding: 10 }}>Waarde</th>
              <th style={{ textAlign: 'center', padding: 10 }}>Auto-WO</th>
              <th style={{ textAlign: 'center', padding: 10 }}>Actief</th>
              <th></th>
            </tr></thead>
            <tbody>
              {afdelingFilters.map(f => (
                <tr key={f.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                  <td style={{ padding: 10 }}>{f.afdeling_naam || f.afdeling_id}</td>
                  <td style={{ padding: 10 }}>{f.filter_veld}</td>
                  <td style={{ padding: 10, fontFamily: 'monospace' }}>{f.filter_waarde}</td>
                  <td style={{ padding: 10, textAlign: 'center' }}><input type="checkbox" checked={f.auto_werkorder} onChange={() => toggleFilter(f, 'auto_werkorder')} /></td>
                  <td style={{ padding: 10, textAlign: 'center' }}><input type="checkbox" checked={f.actief} onChange={() => toggleFilter(f, 'actief')} /></td>
                  <td style={{ padding: 10, textAlign: 'right' }}><button style={{ ...btnDanger, padding: '4px 10px' }} onClick={() => deleteFilter(f.id)}>✕</button></td>
                </tr>
              ))}
              {afdelingFilters.length === 0 && <tr><td colSpan="6" style={{ padding: 30, textAlign: 'center', color: '#9ca3af' }}>Nog geen filters — niets wordt geïmporteerd zonder filter</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'settings' && (
        <div style={card}>
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 12, marginBottom: 12 }}>
            <div><label style={label}>Naam</label><input style={input} value={naam} onChange={e => setNaam(e.target.value)} /></div>
            <div><label style={label}>Sync interval (minuten)</label><input type="number" style={input} value={syncInterval} onChange={e => setSyncInterval(e.target.value)} min="1" /></div>
          </div>
          <label style={label}>Config (JSON)</label>
          <textarea style={{ ...input, fontFamily: 'monospace', fontSize: 12, minHeight: 300 }} value={configText} onChange={e => setConfigText(e.target.value)} spellCheck={false} />
          <p style={{ fontSize: 12, color: '#6b7280', margin: '8px 0' }}>Voor TMS GVB de defaults niet wijzigen. Voor andere bronnen: pas <code>url</code>, <code>headers</code>, <code>response_path</code> en <code>field_mapping</code> aan.</p>
          <button style={btn} onClick={saveKopp} disabled={bezig}>💾 Opslaan</button>
        </div>
      )}

      {tab === 'log' && (
        <div style={card}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead><tr style={{ background: '#f9fafb' }}>
              <th style={{ textAlign: 'left', padding: 10 }}>Tijd</th>
              <th style={{ textAlign: 'left', padding: 10 }}>Extern ID</th>
              <th style={{ textAlign: 'left', padding: 10 }}>Actie</th>
              <th style={{ textAlign: 'left', padding: 10 }}>Status</th>
              <th style={{ textAlign: 'left', padding: 10 }}>Details</th>
            </tr></thead>
            <tbody>
              {logs.map(l => (
                <tr key={l.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                  <td style={{ padding: 10, color: '#6b7280' }}>{new Date(l.created_at).toLocaleString('nl-NL')}</td>
                  <td style={{ padding: 10, fontFamily: 'monospace', fontSize: 12 }}>{l.extern_id}</td>
                  <td style={{ padding: 10 }}>{l.actie}</td>
                  <td style={{ padding: 10 }}><span style={{ background: l.status === 'success' ? '#dcfce7' : '#fee2e2', color: l.status === 'success' ? '#065f46' : '#991b1b', padding: '2px 8px', borderRadius: 12, fontSize: 11 }}>{l.status}</span></td>
                  <td style={{ padding: 10, color: '#6b7280', fontSize: 12 }}>{l.details}</td>
                </tr>
              ))}
              {logs.length === 0 && <tr><td colSpan="5" style={{ padding: 30, textAlign: 'center', color: '#9ca3af' }}>Geen log entries</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
